import { Search, SpaOutlined, ArrowDropDownSharp, RssFeedOutlined, SettingsOutlined, BookmarkBorderOutlined, MessageOutlined, ArchiveOutlined, DeleteOutlined, ExitToAppOutlined } from '@material-ui/icons'
import { Link } from 'react-router-dom'
import React, { useState, useContext } from 'react'
import { Dropdown } from 'react-bootstrap'
import Axios from 'axios'
import { CircularProgress } from '@material-ui/core'
import { useHistory } from 'react-router'

import { AuthContext } from '../../context/AuthContext'
import SearchResultsBar from '../searchResultsBar/SearchResultsBar'

import './topbar.css'

//Dropdown Component
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
)); 


//Topbar Component
const Topbar = () => {

    
    //States
    const [results, setResults] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [isFetching, setIsFetching] = useState(false);

    const history = useHistory()

    const {user} = useContext(AuthContext);

    var typingTimer;

    //Constants
    const PF = process.env.REACT_APP_PUBLIC_FOLDER;
    const API = process.env.REACT_APP_API_URL;

    //Handle Key press event 
    const handleKeyDown = () => {
        clearTimeout(typingTimer)
    }

    //Handle Key release event 
    const handleKeyUp = (e) => {
        const searchInput = e.target.value
        if(searchInput){
            //We give it a while before searching to not overwhelm the server
            clearTimeout(typingTimer)
            typingTimer = setTimeout(async () => {
                setIsFetching(true)
                const {data: {users: searchResults}} = await Axios.get(API + `users/search?username=${searchInput}`)
                setIsFetching(false)
                setIsVisible(true)
                setResults(searchResults)
            }, 2000)
        }
    }

    //Handle the bluring on the search input filed
    const handleBlur = () => {
        clearTimeout(typingTimer)
        setIsVisible(false)
        setResults([])
    }

    //Handle Logout
    const handleLogout = () => {
		localStorage.removeItem("token");
        history.push('/')
		window.location.reload();
	};
    
    return (
        <div className="topbarContainer">
            <div className="topbarLeft">
                <Link to="/" style={{textDecoration: "none"}}>
                    <div className="logo-container">
                        <img className='logo' src={PF + '/person/bloom logo.png'} style={{width: '40px', height: '40px'}}/>
                    </div>
                </Link>
            </div>
            <div className="topbarCenter">
                <div className="searchbar">
                   <div style={{width: '90%'}}>
                        <Search className="searchIcon"/>
                        <input type="text" placeholder="Search for friends here ..." className="searchInput" onKeyUp={handleKeyUp} onKeyDown={handleKeyDown} onBlur={handleBlur}/> 
                   </div>
                    <div>
                        {isFetching && <CircularProgress size={'1.35rem'} className="circularProgress"/>}
                    </div>  
                </div>
                {isVisible && <SearchResultsBar results={results} following={user.following}/>}
            </div>
            <div className="topbarRight">
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Link to={`/profile/${user.username}`}>
                        <img src={user.profilePicture || (PF + "person/default_avatar.jpg")} className="topbarImg" alt="" />
                    </Link>
                    <Dropdown className='dropdown-button'>
                        <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
                            <ArrowDropDownSharp style={{color: '#8a8a8a'}}/>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{marginTop: '1rem'}}>
                            <Dropdown.Item as={Link} to="/saved">
                                <BookmarkBorderOutlined style={{marginRight: '.5rem'}}/>
                                Saved
                            </Dropdown.Item>
                            <Dropdown.Item as={Link} to="/editProfile">
                                <SettingsOutlined style={{marginRight: '.5rem'}}/>
                                Settings
                            </Dropdown.Item>
                            <a href="/roger" className='dropdown-item'>
                                <MessageOutlined style={{marginRight: '.5rem'}}/>
                                Messages
                            </a>
                            {/* <Dropdown.Item as={Link} to="/roger">
                                <MessageOutlined style={{marginRight: '.5rem'}}/>
                                Messages
                            </Dropdown.Item> */}
                            <Dropdown.Item as={Link} to="/archive">
                                <ArchiveOutlined style={{marginRight: '.5rem'}}/>
                                Archive
                            </Dropdown.Item>
                            <Dropdown.Item as={Link} to="/trash">
                                <DeleteOutlined style={{marginRight: '.5rem'}}/>
                                Trash
                            </Dropdown.Item>
                            <hr />
                            <Dropdown.Item as={Link} to="/" onClick={handleLogout}>
                                <ExitToAppOutlined style={{marginRight: '.5rem'}}/>
                                Logout
                            </Dropdown.Item>
                        </Dropdown.Menu>  
                    </Dropdown>
                </div>
            </div>
        </div>
    )
}

export default Topbar
